"use client";

import {
	Action,
	Dialog,
	DialogContent,
	HStack,
	Icon,
	Link,
	SimpleParagraph,
	Subheadline,
	VStack,
} from "@jace/ui";
import { ReactNode, useState } from "react";
import { LineSkeleton } from "../inbox/email-draft-skeleton";

const lines = new Array(3).fill(null).map((_, i) => i);

function Pinned({ children }: { children: ReactNode }) {
	const [isOpen, setIsOpen] = useState(true);

	if (!isOpen) {
		return null;
	}

	return (
		<VStack className="fixed left-lg bottom-lg max-md:left-md max-md:bottom-md max-md:right-md max-w-[420px] z-50 bg-message-user-background rounded-message gap-md items-center border border-message-user-border overflow-hidden">
			<Action
				icon="close"
				className="absolute top-md right-md"
				onClick={() => {
					setIsOpen(false);
				}}
			/>
			{children}
		</VStack>
	);
}

function MissingScopesContent({ children }: { children?: ReactNode }) {
	const [isOpen, setIsOpen] = useState(true);

	if (!isOpen) {
		return null;
	}

	return (
		<>
			<div className="w-full bg-surface-input py-2xl">
				<VStack className="py-xl gap-md w-[80%] mx-auto">
					{lines.map((l) => (
						<HStack className="items-center gap-lg" key={l}>
							<LineSkeleton />
							<Icon
								kind="done-filled"
								className="text-surface-highlight-soprano"
							/>
						</HStack>
					))}
				</VStack>
			</div>
			<VStack className="px-2xl pt-md pb-2xl gap-md">
				<Subheadline className="mt-0 mb-sm leading-7 text-left w-full">
					Why We Ask for Google Permissions
				</Subheadline>
				<SimpleParagraph className="text-text-body-muted w-full text-left">
					To give you the best experience, we request access to your email,
					contacts, and other relevant info through Google.
				</SimpleParagraph>
				<SimpleParagraph className="text-text-body-muted w-full text-left">
					These permissions help us personalize your experience, connect you
					with your network, and keep everything secure and seamless. We only
					access what’s necessary—nothing more—and your data is always handled
					with care.{" "}
				</SimpleParagraph>
				<Link
					className="text-md text-left w-full mt-md"
					href="https://zeta-labs.notion.site/terms-of-use"
				>
					Learn more
				</Link>
				{children}
			</VStack>
		</>
	);
}

export function MissingScopes({
	children,
	asModal,
}: { children?: ReactNode; asModal?: boolean }) {
	if (asModal) {
		return (
			<Dialog defaultOpen={true}>
				<DialogContent className="p-0 overflow-hidden max-w-[460px]">
					<MissingScopesContent>{children}</MissingScopesContent>
				</DialogContent>
			</Dialog>
		);
	}

	return (
		<Pinned>
			<MissingScopesContent>{children}</MissingScopesContent>
		</Pinned>
	);
}
